import "./zod-config";
import "./styles.css";
import { Toaster } from "@platform/ui";
import { SessionProvider } from "@platform/ui/features";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { OperatorLayout } from "./components/layout";
import { I18nProvider } from "./lib/i18n";
import { session } from "./lib/session";
import { AuditPage } from "./pages/audit";
import { CategoriesPage } from "./pages/categories";
import { CategorySchemaPage } from "./pages/category-schema";
import { ConversationMessagesPage } from "./pages/conversation-messages";
import { DashboardPage } from "./pages/dashboard";
import { DisputePage, DisputesPage } from "./pages/disputes";
import { EnterprisePage, EnterprisesPage } from "./pages/enterprises";
import { OrderPage, OrdersPage } from "./pages/orders";
import { ProductReviewPage } from "./pages/product-review";
import { ProductReviewsPage } from "./pages/product-reviews";
import { ProductsPage } from "./pages/products";
import { RiskListsPage } from "./pages/risk-lists";
import { SettingsPage } from "./pages/settings";
import { SignInPage } from "./pages/sign-in";
import { VerificationQueuePage } from "./pages/verification-queue";

const router = createBrowserRouter([
  { path: "/sign-in", element: <SignInPage /> },
  {
    element: <OperatorLayout />,
    children: [
      { path: "/", element: <DashboardPage /> },
      { path: "/verification", element: <VerificationQueuePage /> },
      { path: "/verification/:caseId", element: <VerificationQueuePage /> },
      { path: "/enterprises", element: <EnterprisesPage /> },
      { path: "/enterprises/:enterpriseId", element: <EnterprisePage /> },
      { path: "/orders", element: <OrdersPage /> },
      { path: "/orders/:orderId", element: <OrderPage /> },
      { path: "/disputes", element: <DisputesPage /> },
      { path: "/disputes/:caseId", element: <DisputePage /> },
      { path: "/conversations/:conversationId/messages", element: <ConversationMessagesPage /> },
      { path: "/audit", element: <AuditPage /> },
      { path: "/product-reviews", element: <ProductReviewsPage /> },
      { path: "/product-reviews/:reviewId", element: <ProductReviewPage /> },
      { path: "/products", element: <ProductsPage /> },
      { path: "/categories", element: <CategoriesPage /> },
      { path: "/categories/:categoryId/schema", element: <CategorySchemaPage /> },
      { path: "/risk-lists", element: <RiskListsPage /> },
      { path: "/settings", element: <SettingsPage /> },
    ],
  },
]);

const root = document.getElementById("root");
if (root === null) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <SessionProvider session={session}>
        <RouterProvider router={router} />
      </SessionProvider>
      <Toaster />
    </I18nProvider>
  </StrictMode>,
);
